var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BackendHttpService } from '../../core/backend-http.service';
import { apiEndpoints } from '../../app.constants';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
var DiscoverService = /** @class */ (function (_super) {
    __extends(DiscoverService, _super);
    function DiscoverService(router, translate, influencerService) {
        var _this = _super.call(this, router, translate) || this;
        _this.router = router;
        _this.translate = translate;
        _this.influencerService = influencerService;
        /**
         * using to prevent infinitive scroll trigger loader next result when scrolling to last position
         */
        _this._onScrollToPreviousPosition = false;
        _this._cacheScrollPositionOnDiscover = true;
        _this._isActiveDiscoverPage = false;
        /**
         * Since discover component will never destroyed after initializing.
         * So, this subject will be help to control behaviour whenever user leave discover page
         * @type {BehaviorSubject<boolean>}
         * @private
         */
        _this._moveOutDiscoverSubject = new BehaviorSubject(false);
        return _this;
    }
    DiscoverService.prototype.getInfluencerGroupListSideBarMenu = function (companyId) {
        var apiUrl = apiEndpoints.getInfluencerGroupListSideBarMenu;
        return this.get(apiUrl, { selected_company_id: companyId }).map(function (res) { return res ? res.data.map(function (item) { return ({
            id: item.influencer_group_id,
            name: item.influencer_group_name
        }); }) : []; });
    };
    DiscoverService.prototype.searchInfluencers = function (searchFilter) {
        var _this = this;
        var result = this.post(apiEndpoints.discoverSearchInfluencers, JSON.stringify(searchFilter));
        if (!result) {
            return Observable.of({
                influencers: [],
                lastSortValues: null,
                totalInfluencers: null
            });
        }
        return result.map(function (res) {
            if (!res.data.influencers) {
                res.data.influencers = [];
                return res.data;
            }
            res.data.influencers = res.data.influencers.map(function (item) {
                var remappedItem = _this.remapInfluencerResult(item);
                if (remappedItem.relativepath) {
                    remappedItem.relativepath = remappedItem.relativepath.replace(/www.instagram.com\/|www.youtube.com\/user\//, '');
                }
                return remappedItem;
            });
            return res.data;
        });
    };
    /**
     * Remap new Discover result to old model
    */
    DiscoverService.prototype.remapInfluencerResult = function (newInfluencer) {
        return {
            'id': newInfluencer.influencerId,
            'url': null,
            'url_hash': null,
            'impressions': newInfluencer.impression,
            'engagement': newInfluencer.engagement,
            'reach': newInfluencer.reach,
            'impact': newInfluencer.impact * 100,
            'keyword_id': 0,
            'keyword': null,
            'keyword_type_id': 0,
            'project_id': 0,
            'date': newInfluencer.urlDate,
            'datePublished': null,
            'topMention': (newInfluencer.topMentions) ? newInfluencer.topMentions.map(function (mention) { return mention.mention; }).join(', ') : '',
            'imageUrl': newInfluencer.profilePicture,
            'title': null,
            'blog_id': newInfluencer.influencerId,
            'urlType': 0,
            'domain': newInfluencer.domain,
            'influencerName': newInfluencer.influencerName,
            'influencer_id': newInfluencer.influencerId,
            'influencer_name': newInfluencer.influencerName,
            'influencer_image': newInfluencer.profilePicture,
            'influencer_country': null,
            'influencer_country_id': newInfluencer.country ? newInfluencer.country.id : null,
            'countryCode': newInfluencer.country ? newInfluencer.country.code : null,
            'country_code': newInfluencer.country ? newInfluencer.country.code : null,
            'topics': null,
            'verticals': null,
            'country': null,
            'rankingMetric': 0,
            'relativepath': (newInfluencer.channels && newInfluencer.channels.length > 0) ? newInfluencer.channels[0].relativePath : null,
            'platforms': (newInfluencer.channels && newInfluencer.channels.length > 0) ? this.getPlatformNames(newInfluencer.channels.map(function (c) { return c.platform.id; })) : [],
            'influencerChannels': (newInfluencer.channels && newInfluencer.channels.length > 0) ? this.getPlatformNames(newInfluencer.channels.map(function (c) { return c.platform.id; })) : [],
            'gender': newInfluencer.gender,
            'followers': newInfluencer.numberOfFollowers,
            'numberOfFollowers': newInfluencer.numberOfFollowers,
            'numberOfPosts': newInfluencer.numberOfPosts,
            'numOfPostThisMonth': 0,
            'favoriteTopics': newInfluencer.topTopics ? newInfluencer.topTopics.map(function (tt) { return tt.name; }).join(', ') : null,
            'channels': newInfluencer.channels
        };
    };
    DiscoverService.prototype.searchPosts = function (searchFilter) {
        var _this = this;
        return this.post(apiEndpoints.discoverSearchPosts, JSON.stringify(searchFilter)).map(function (res) {
            // if the result is empty. Stop immediately
            if (!res.data.posts) {
                res.data.posts = [];
                return res.data;
            }
            // map the DiscoverPost to correct model
            res.data.posts = res.data.posts.map(function (item) {
                return _this.remapDiscoverPostResult(item);
            });
            return res.data;
        });
    };
    /**
     * Remap new Discover Post result to old model
     */
    DiscoverService.prototype.remapDiscoverPostResult = function (newPost) {
        return {
            blog_id: newPost.influencerId,
            channel: newPost.channel,
            country: null,
            countryCode: null,
            date: newPost.publishedDate,
            datePublished: null,
            domain: null,
            engagement: newPost.engagement,
            followers: null,
            gender: null,
            id: newPost.influencerId,
            imageUrl: newPost.imageUrl,
            videoUrl: newPost.videoUrl,
            impact: newPost.impact * 100,
            impressions: (newPost.platform && newPost.platform.id !== 2 ? newPost.impression : newPost.reach),
            influencerName: newPost.influencerName,
            influencer_country: null,
            influencer_country_id: null,
            influencer_name: newPost.influencerName,
            keyword: null,
            keyword_id: 0,
            keyword_type_id: 0,
            mentions: newPost.mentions,
            numberOfPosts: null,
            platforms: null,
            project_id: 0,
            rankingMetric: 0,
            reach: newPost.reach,
            relativepath: newPost.relativePath || '',
            title: newPost.title,
            topics: null,
            url: newPost.fullUrl,
            urlType: 0,
            url_hash: newPost.urlHash,
            urlHash: newPost.urlHash,
            verticals: null,
            influencer_id: newPost.influencerId,
            numberOfFollowers: null,
            topMention: newPost.mentions ? newPost.mentions.join(', ') : '',
            platform: this.getPlatformName(newPost.platform ? newPost.platform.id : -1),
            platformId: newPost.platform ? newPost.platform.id : 0,
            handle: (newPost.relativePath || '').replace(/www.instagram.com\/|www.youtube.com\/user\//, ''),
            isStory: newPost.story,
            completed: this.influencerService.isInstagramStoryVideo(newPost) ? newPost.completed : true,
            isVideo: this.influencerService.isVideoPost(newPost),
            mediaWidth: newPost.mediaWidth,
            mediaHeight: newPost.mediaHeight,
            imageWidth: newPost.imageWidth,
            imageHeight: newPost.imageHeight,
            postType: newPost.postType
        };
    };
    /**
     * this method use to add multiple posts to project
     * @param influencerGroupAdding
     * @returns {Observable<any>}
     */
    DiscoverService.prototype.addPostsToProject = function (addPostToProject) {
        return this.post(apiEndpoints.addPostsManuallyIntoProject.replace(':project_id', String(addPostToProject.projectId)), { posts: addPostToProject.posts });
    };
    Object.defineProperty(DiscoverService.prototype, "isScrollingToPreviousPosition", {
        get: function () {
            return this._onScrollToPreviousPosition;
        },
        enumerable: true,
        configurable: true
    });
    DiscoverService.prototype.onScrollToPreviousPosition = function (isScrolling) {
        this._onScrollToPreviousPosition = isScrolling;
    };
    Object.defineProperty(DiscoverService.prototype, "isAllowToCacheScrollPosition", {
        get: function () {
            return this._cacheScrollPositionOnDiscover;
        },
        enumerable: true,
        configurable: true
    });
    DiscoverService.prototype.enableCachingScrollPosition = function () {
        this._cacheScrollPositionOnDiscover = true;
    };
    DiscoverService.prototype.disableCachingScrollPosition = function () {
        this._cacheScrollPositionOnDiscover = false;
    };
    Object.defineProperty(DiscoverService.prototype, "isActiveDiscoverPage", {
        get: function () {
            return this._isActiveDiscoverPage;
        },
        enumerable: true,
        configurable: true
    });
    DiscoverService.prototype.activeDiscoverPage = function () {
        this._isActiveDiscoverPage = true;
    };
    DiscoverService.prototype.inactiveDiscoverPage = function () {
        this._isActiveDiscoverPage = false;
    };
    Object.defineProperty(DiscoverService.prototype, "moveOutDiscoverSubject", {
        get: function () {
            return this._moveOutDiscoverSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    DiscoverService.prototype.onLeaveDiscoverPage = function (isMoveOut) {
        this._moveOutDiscoverSubject.next(isMoveOut);
    };
    /**
     * Get platform name from platformId and set it as an array
     * @param platformId
     */
    DiscoverService.prototype.getPlatformName = function (platformId) {
        var platformNames = [];
        platformNames.push(this.influencerService.getPlatformNameById(platformId));
        return platformNames.join(', ');
    };
    DiscoverService.prototype.getPlatformNames = function (platformIds) {
        var _this = this;
        var platforms = this.filterDuplicatePlatforms(platformIds);
        var orderPlatforms = platforms.sort(function (p1, p2) { return p1 - p2; });
        var platformNames = orderPlatforms.map(function (item) { return _this.influencerService.getPlatformNameById(item); });
        return platformNames.join(', ');
    };
    DiscoverService.prototype.filterDuplicatePlatforms = function (platformIds) {
        var platforms = [];
        platformIds.filter(function (item) {
            if (!platforms.includes(item)) {
                platforms.push(item);
            }
        });
        return platforms;
    };
    return DiscoverService;
}(BackendHttpService));
export { DiscoverService };



// WEBPACK FOOTER //
// ./src/app/services/discover/discover.service.ts.pre-build-optimizer.js